import React, { memo } from 'react';
import PropTypes from 'prop-types';

import styles from './styles/Button.module.css';

const Button = ({
    children,
    onClick,
    href,
    disabled = false,
    variant = 'primary',
    size = 'medium',
    className = '',
    title,
    type = 'button',
    ...props
}) => {
    const sizeClass = styles[`size-${size}`];
    const variantClass = styles[`variant-${variant}`];
    const combinedClassName = `${styles.button} ${sizeClass} ${variantClass} ${className}`.trim();

    if (href) {
        return (
            <a href={href} className={combinedClassName} title={title} {...props}>
                {children}
            </a>
        );
    }

    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={combinedClassName}
            title={title}
            {...props}
        >
            {children}
        </button>
    );
};

Button.propTypes = {
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func,
    href: PropTypes.string,
    disabled: PropTypes.bool,
    variant: PropTypes.oneOf(['primary', 'secondary', 'danger', 'outline']),
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    className: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.oneOf(['button', 'submit', 'reset']),
};

export default memo(Button);
